import {UAParser} from 'ua-parser-js';

export const getUserAgent = () => {
  const {browser, cpu, device, os} = UAParser();

  const browserString = [browser.name, browser.version]
    .filter(Boolean)
    .join(' ');
  const osString = [os.name, os.version].filter(Boolean).join(' ');

  const result = [browserString, osString];

  /**
   * If the device type is set, it means (most likely) that the device is not a desktop device
   *
   * @see https://docs.uaparser.dev/info/device/type.html
   */
  if (device.type) {
    const deviceString = [device.vendor, device.model]
      .filter(Boolean)
      .join(' ');

    result.push(deviceString);
  }

  const cpuString = cpu.architecture;

  if (cpuString) {
    result.push(cpuString);
  }

  return result.join(' | ');
};
